export const setUserAuthorization = (data) => {
  window.sessionStorage.setItem(process.env.REACT_APP_USER_AUTHORIZATION_KEY, JSON.stringify(data));
};

export const setUserAuthentication = (data) => {
  window.sessionStorage.setItem(process.env.REACT_APP_USER_AUTHENTICATION_KEY, JSON.stringify(data));
};

/**
 * Check if there is a current google login session stored on session storage
 * @returns {JSON} Returns the current login session from google.
 */
const getUserAuthorization = () => {
  try {
    const userAuthorization = window.sessionStorage.getItem(process.env.REACT_APP_USER_AUTHORIZATION_KEY);
    const parsedUserAuthorization = JSON.parse(userAuthorization);
    return parsedUserAuthorization;
  } catch {
    return null;
  }
};

/**
 * Check if there are google account details stored on session storage
 * @returns {JSON} Returns the user details from google.
 */
const getUserAuthentication = () => {
  try {
    const userAuthentication = window.sessionStorage.getItem(process.env.REACT_APP_USER_AUTHENTICATION_KEY);
    const parsedUserAuthentication = JSON.parse(userAuthentication);
    return parsedUserAuthentication;
  } catch {
    return null;
  }
};

export const removeUserAccess = () => {
  window.sessionStorage.removeItem(process.env.REACT_APP_USER_AUTHENTICATION_KEY);
  window.sessionStorage.removeItem(process.env.REACT_APP_USER_AUTHORIZATION_KEY);
};

export const getEncodedUserCredentials = () => {
  const userCredentials = getUserAuthentication();
  return userCredentials?.credential;
};

export const getAccessToken = () => {
  const gcpAuthResponse = getUserAuthorization();
  return gcpAuthResponse?.access_token;
};
